import { AppSettings } from "../../../entities/AppSettings";


export const appSettings: AppSettings = {
  authority: '',
  client_id: '',
  scope: '',
  apiServiceAddress: '',
  controllerRouteRoot: '/api',
  bimApiServiceAddress: '',
  dashApiServiceAddress: '',
  ovmApiServiceAddress: '',

  primaryUrl: '',
  secondaryUrl: '',
  functionalCurrency: { symbol: 'R ' },
  currencies: [],
  supplierCurrency: { currency: 'R', description: 'Rand', buyExchangeRate: 1, buyMulDiv: 'M' },
  //supplierCurrency: { currency: 'USD', description: 'US Dollar', buyExchangeRate: 19.64, buyMulDiv: 'M' },
  get currentCurrency() {
    if (this.overrideFunctionalCurrencyId) {
      var currency = this.currencies.find(o => o.id == this.overrideFunctionalCurrencyId);
      if (currency) {
        return currency
      }
      else return this.functionalCurrency
    }
    return this.functionalCurrency;
  },
  get currentSupplierCurrency() {
    if (this.supplierCurrency) {
      return this.supplierCurrency;
    }
    else return this.supplierCurrency
  }
};

export const appStyleSettings = {
  //formFieldsLabelSeperate: false,//true
  //formControlAppearance: 'outline', //'standard'
  //floatLabel: 'always'//'auto'

  formFieldsLabelSeperate: false,
  formControlAppearance: 'outline',
  floatLabel: 'auto'
}
